import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'bucke-loading',
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
    loading = input<boolean>(true);
}
